<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import {
    disabled,
    type IndexingEntry,
  } from "module/store/IndexingDisabledStore";

  const dispatch = createEventDispatcher();

  let {
    row,
  }: {
    row: IndexingEntry;
  } = $props();

  let disabledRoles = $derived(
    row.documentType && row.documentType in $disabled.entities
      ? $disabled.entities[row.documentType]
      : []
  );

  let checked = $derived(Object.values(row.enabled).some((v) => v));
  let indeterminate = $derived(
    checked && !Object.values(row.enabled).every((v) => v)
  );

  const all = [1, 2, 3, 4] as const;
  let allDisabled = $derived(all.every((r) => disabledRoles.includes(r)));

  const checkAll = (evt: MouseEvent) =>
    dispatch("change", {
      disabled: !(evt.target as HTMLInputElement).checked || indeterminate,
    });

  const check = (role: number) => (evt: MouseEvent) =>
    dispatch("change", {
      role: role,
      disabled: !(evt.target as HTMLInputElement)?.checked,
    });
</script>

<div
  class="form-group"
  class:sublevel={row.type === "directory" && row.id !== "root"}
>
  <div class="row-label">
    <input
      type="checkbox"
      name="{row.id}.All"
      id="{row.id}.All"
      {checked}
      {indeterminate}
      disabled={allDisabled}
      onclick={checkAll}
    />
    <label class="index" for="{row.id}.All">
      {row.title}
      {#if row.subTitle}<span class="hint">{row.subTitle}</span>{/if}
    </label>
  </div>
  <div class="form-fields">
    <input
      type="checkbox"
      name="{row.id}.1"
      id="{row.id}.1"
      checked={row.enabled[1]}
      disabled={disabledRoles.includes(1)}
      onclick={check(1)}
    />
    <input
      type="checkbox"
      name="{row.id}.2"
      id="{row.id}.2"
      checked={row.enabled[2]}
      disabled={disabledRoles.includes(2)}
      onclick={check(2)}
    />
    <input
      type="checkbox"
      name="{row.id}.3"
      id="{row.id}.3"
      checked={row.enabled[3]}
      disabled={disabledRoles.includes(3)}
      onclick={check(3)}
    />
    <input
      type="checkbox"
      name="{row.id}.4"
      id="{row.id}.4"
      checked={row.enabled[4]}
      disabled={disabledRoles.includes(4)}
      onclick={check(4)}
    />
  </div>
</div>

<style>
  .form-group {
    padding: 0.2em;
    margin: 0;
    align-items: center;
    border-top: 1px solid var(--color-border-dark-4);
    color: var(--color-form-label);
  }
  .form-group.sublevel .row-label {
    padding-left: 2em;
  }

  .form-group label {
    font-weight: bold;
  }
  .form-group:hover {
    color: var(--color-form-label-hover);
  }
  .row-label {
    flex: 0 0 calc(45% + 0.4em);
    display: flex;
    align-items: center;
  }
  .row-label label {
    flex: unset;
  }

  .form-fields {
    justify-content: space-around;
  }

  input:disabled {
    opacity: 0.6;
    filter: saturate(0);
  }
</style>
